import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import userminus from "../../../assets/img/user-minus.svg";

const Unfollowpopup = (props)=>{
const closePopup =() =>{
  props.CancelPopup();
}
const unfollow=()=>{
  props.LeaveOrganization(props.organizationId);
}

return(
<div>
      <Modal show={props.isConfirm} onHide={props.CancelPopup}
       dialogClassName="small-custom-modal  modal-dialog-centered">
        <Modal.Header closeButton>
        <div className="popupheader">
        <div className="mod-bor-icon" >
       <img src={userminus} alt="Join" className="join-icon" />
            </div>
            <div className="header">
              <div className="signuup">Unfollow</div>
              <p className="Stronger">{props.organizationName}</p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div>
          <p className="fov-text">Do you want to leave the organization?</p>
          </div>
       
        </Modal.Body>

          <Modal.Footer className="full-w" >
                         <button type="button" className="cancel-btn" onClick={()=>closePopup()}>No</button>
                          <button className="next-btn"  onClick={()=>unfollow()}>Yes</button>
                </Modal.Footer>
      
      </Modal>
      
    </div>
);
  

};
export default Unfollowpopup;